/**
 * portal loading
 */
import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import styles from './index.module.scss';

const Index: React.FC = () => {
  return (
    <div className={styles.loadingWrapper}>
      <div className={styles.loadingContent}>
        <Spin spinning size="large" indicator={<LoadingOutlined />} />
      </div>
    </div>
  );
};

export default Index;
